"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgRustore = function SvgRustore(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.36 44c-7.24 0-10.861 0-13.11-2.25C12 39.503 12 35.882 12 28.64v-1.28c0-7.24 0-10.861 2.25-13.11C16.498 12 20.12 12 27.36 12h1.28c7.24 0 10.861 0 13.11 2.25C44 16.499 44 20.12 44 27.36v1.28c0 7.241 0 10.861-2.25 13.11C39.502 44 35.88 44 28.64 44h-1.28Zm7.182-11.271 2.162.54a1.55 1.55 0 0 0 1.929-1.497V21.351a1.93 1.93 0 0 0-1.467-1.871l-6.201-1.55a1.55 1.55 0 0 0-1.929 1.497v1.88l-3.907-.977a1.55 1.55 0 0 0-1.929 1.497v1.878l-3.907-.976a1.55 1.55 0 0 0-1.93 1.497v10.421c0 .885.605 1.656 1.468 1.872l6.201 1.549a1.55 1.55 0 0 0 1.929-1.497v-1.733h-.002l.002-8.673a1.96 1.96 0 0 0-.757-1.545.093.093 0 0 1-.022-.126.11.11 0 0 1 .123-.044c.817.247 1.598 1.085 1.677 2.138l.27 7.958a.63.63 0 0 0 .42.574l2.196.548a1.55 1.55 0 0 0 1.929-1.497l.002-10.404c0-.88-.556-1.39-.758-1.546a.093.093 0 0 1-.021-.125.11.11 0 0 1 .122-.044c.817.247 1.599 1.084 1.677 2.137l.27 7.959a.625.625 0 0 0 .453.58Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgRustore);
var _default = exports["default"] = Memo;